module.exports = __webpack_public_path__ + "static/img/in-efu-life.68af969.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/in-efu-life.png
// module id = UCMg
// module chunks = 1